import { autorun, makeAutoObservable, runInAction } from "mobx";
import { Entity } from "@/app_store/stream/entity";
import { Account, AccountSettings } from "@/app_store/account";


export interface Theme {
    id: string;
    name: string;
    bg: string;
    accent: string;
}

export interface Language {
    id: string;
    name: string;
    nativeName: string;
}

export const LANGUAGES: Language[] = [
    { id: "en", name: "English",    nativeName: "English" },
    { id: "pl", name: "Polish",     nativeName: "Polski" },
    { id: "ua", name: "Ukrainian",  nativeName: "Українська" },
];

export const THEMES: Theme[] = [
    { id: "darcula",  name: "Darcula",   bg: "#232425", accent: "#2f65ca" },
    { id: "dark",     name: "Dark+",     bg: "#1e1e1e", accent: "#007acc" },
    { id: "monokai",  name: "Monokai",   bg: "#272822", accent: "#a6e22e" },
    { id: "dracula",  name: "Dracula",   bg: "#282a36", accent: "#bd93f9" },
    { id: "light",    name: "Light+",    bg: "#ffffff", accent: "#005fb8" },
];


const MOBILE_QUERY = "(max-width: 768px)";

export class SettingsStore {
    root: any;
    draft: Entity<Account> | null = null;
    isMobile: boolean = window.matchMedia(MOBILE_QUERY).matches;

    constructor(root: any) {
        this.root = root;
        makeAutoObservable(this, { root: false });

        const mq = window.matchMedia(MOBILE_QUERY);
        mq.addEventListener("change", (e) => {
            runInAction(() => { this.isMobile = e.matches; });
        });

        autorun(() => {
            const theme = this.isMobile
                ? (this.currentSettings?.theme_mobile ?? "darcula")
                : (this.currentSettings?.theme_desktop ?? "darcula");
            document.documentElement.setAttribute("data-theme", theme);
        });
    }

    get currentSettings(): AccountSettings | null {
        return this.draft?.value.settings ?? this.root.account.settings;
    }

    testSettings(partial: Partial<AccountSettings>) {
        const accountId = this.root.account.account?.id;
        const accountEntity: Entity<Account> | null = accountId
            ? this.root.account.repository.get(accountId)
            : null;
        this.draft = accountEntity?.copy() ?? null;
        if (this.draft) {
            const current = this.draft.value.settings;
            this.draft.update({ settings: { ...current, ...partial } });
        }
    }

    revertSettings() {
        this.draft = null;
    }

    saveSettings() {
        if (this.draft) {
            this.root.account.repository.save(this.draft);
            this.draft = null;
        }
    }
}
